<div class="d-flex align-items-center {{className}}">
    <p class="order-ship-text">
        {{params.value}}
    </p>
</div>